import { motion } from 'framer-motion'
import { DollarSign, Zap, Settings, Eye } from 'lucide-react'

const WhyChooseUs = () => {
  const values = [
    {
      icon: DollarSign,
      title: "Cheaper",
      description: "Fraction of traditional costs with serverless, usage-based architecture."
    },
    {
      icon: Zap,
      title: "Faster",
      description: "Initial interviews in minutes, not days. Reduce time-to-first-screen dramatically."
    },
    {
      icon: Settings,
      title: "Flexible",
      description: "Bring your own LLM, TTS, or STT. Swap providers without vendor lock-in."
    },
    {
      icon: Eye,
      title: "Transparent",
      description: "Pay per meet or per minute. No hidden fees. Cost controls built-in."
    }
  ]

  return (
    <section id="why" className="section bg-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Us
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="p-6 bg-gray-50 rounded-2xl hover:bg-white hover:shadow-lg transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <value.icon className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary-600 mb-2">
                    {value.title}
                  </h3>
                  <p className="text-gray-600">
                    {value.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs
